const initState = {
    StateOfForm: 'closed',
    selectedCourse: '',


};

const publishCoursesReducer = (state=initState, action) => {
    
    switch (action.type) {

        case 'PUBLISH_COURSE_DISPATCH':
            return {
                ...state,

            }

        case 'INITIATE_STRIPE_CONNECT_ACCOUNT_DISPATCH':
            return{

            }
        case 'FINALIZE_STRIPE_CONNECT_ACCOUNT_DISPATCH':
            return{

            }

        case 'SAVE_STRIPE_CONNECT_ACCOUNT_DISPATCH':

            return{
                
            }

        case 'SAVE_STRIPE_CONNECT_ACCOUNT_DISPATCH_ERROR':
            return{

            }

        default:

            return state;
           
    }

}

export default publishCoursesReducer